import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default defineNuxtPlugin((nuxtApp) => {});
